import {WebSpeechDictationAdapter, type DictationAdapter} from '@assistant-ui/react'

/**
 * Browser Web Speech dictation for the composer. Undefined when the runtime
 * cannot listen (jsdom, unsupported browsers) so the mic control stays hidden.
 */
export function createOmicsDictationAdapter(): DictationAdapter | undefined {
  if (!WebSpeechDictationAdapter.isSupported()) return undefined
  return new WebSpeechDictationAdapter({
    language: 'en-US',
    continuous: true,
    interimResults: true,
  })
}
